import vars from "../_vars";
import { isMobile } from "../functions/check_client_width";

const OFFSET_RATIO = 0.1;

export default function linearBorder() {
  const elements = vars.documentEl.querySelectorAll(".linear-border");

  if (!elements.length || isMobile()) return;

  vars.windowEl.addEventListener("mousemove", ({ clientX }) => {
    const ratio = (clientX / vars.windowEl.innerWidth - 0.5) * 2;

    elements.forEach((el) => {
      const offset = ratio * el.offsetWidth * OFFSET_RATIO;
      el.style.setProperty("--linear-offset", `${offset}px`);
    });
  });
}
